(function () {
  'use strict';

  var GRID      = 'product-grid';
  var CONTAINER = 'ProductGridContainer';
  var LOADER    = 'di-scroll-loader';
  var SENTINEL  = 'di-scroll-sentinel';

  var loading  = false;
  var observer = null;

  /* ── Aggiunge preview_theme_id all'URL se in anteprima ──── */
  function previewUrl(url) {
    var m = window.location.search.match(/preview_theme_id=([^&]+)/);
    if (!m) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'preview_theme_id=' + m[1];
  }

  /* ── URL della pagina successiva ────────────────────────── */
  function nextUrl() {
    var el = document.querySelector('.pagination-wrapper[data-next-url]');
    return el ? el.getAttribute('data-next-url') : null;
  }

  function setNextUrl(url) {
    var el = document.querySelector('.pagination-wrapper');
    if (!el) return;
    if (url) el.setAttribute('data-next-url', url);
    else     el.removeAttribute('data-next-url');
  }

  /* ── Nasconde la paginazione numerica ───────────────────── */
  function hidePagination() {
    document.querySelectorAll('.pagination-wrapper').forEach(function(el) {
      el.style.display = 'none';
    });
  }

  /* ── Loader tre pallini ─────────────────────────────────── */
  function showLoader() {
    if (document.getElementById(LOADER)) return;
    var div = document.createElement('div');
    div.id = LOADER;
    div.setAttribute('aria-hidden', 'true');
    div.innerHTML = '<div class="di-loader-dots"><span></span><span></span><span></span></div>';
    var g = document.getElementById(GRID);
    if (g && g.parentNode) g.parentNode.insertBefore(div, g.nextSibling);
  }

  function hideLoader() {
    var el = document.getElementById(LOADER);
    if (el) el.remove();
  }

  /* ── Carica la pagina successiva ────────────────────────── */
  function loadNext() {
    if (loading) return;
    var url = nextUrl();
    if (!url) { teardown(); return; }

    loading = true;
    showLoader();

    fetch(previewUrl(url), { credentials: 'same-origin' })
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        /* Appendi nuovi prodotti */
        var src = doc.getElementById(GRID);
        var dst = document.getElementById(GRID);
        if (src && dst) {
          src.querySelectorAll('li.grid__item').forEach(function(li) {
            var clone = li.cloneNode(true);
            clone.classList.add('di-fade-item');
            dst.appendChild(clone);
          });
        }

        /* Aggiorna URL prossima pagina */
        var nw = doc.querySelector('.pagination-wrapper[data-next-url]');
        setNextUrl(nw ? nw.getAttribute('data-next-url') : null);
        hidePagination();
      })
      .catch(function(err) {
        console.warn('[DE.COR. Infinite Scroll]', err);
      })
      .then(function() {
        /* === finally === */
        loading = false;
        hideLoader();
        if (nextUrl()) {
          placeSentinel();
        } else {
          teardown();
        }
      });
  }

  /* ── Controlla se il fondo della griglia è visibile ─────── */
  function nearBottom() {
    if (loading || !nextUrl()) return false;
    var g = document.getElementById(GRID);
    if (!g) return false;
    return g.getBoundingClientRect().bottom < window.innerHeight + 1200;
  }

  /* ── Scroll event listener (fallback + trigger primario) ── */
  function onScroll() {
    if (nearBottom()) loadNext();
  }

  /* ── Sentinel con IntersectionObserver ──────────────────── */
  function placeSentinel() {
    /* Rimuovi sentinel precedente */
    var old = document.getElementById(SENTINEL);
    if (old) old.remove();
    if (observer) { observer.disconnect(); observer = null; }

    var g = document.getElementById(GRID);
    if (!g || !g.parentNode) return;

    var s = document.createElement('div');
    s.id = SENTINEL;
    s.style.cssText = 'height:1px;width:100%;pointer-events:none;';
    g.parentNode.insertBefore(s, g.nextSibling);

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting && !loading && nextUrl()) loadNext();
      }, { rootMargin: '1200px 0px' });
      observer.observe(s);
    }
  }

  /* ── Cleanup finale ─────────────────────────────────────── */
  function teardown() {
    var s = document.getElementById(SENTINEL);
    if (s) s.remove();
    if (observer) { observer.disconnect(); observer = null; }
    window.removeEventListener('scroll', onScroll);
  }

  /* ── MutationObserver: re-init dopo filtri / ordinamento ── */
  function watchContainer() {
    var c = document.getElementById(CONTAINER);
    if (!c) return;
    new MutationObserver(function() {
      setTimeout(function() {
        loading = false;
        hideLoader();
        hidePagination();
        if (nextUrl()) {
          placeSentinel();
          onScroll();
        } else {
          teardown();
        }
      }, 200);
    }).observe(c, { childList: true, subtree: false });
  }

  /* ── Init ───────────────────────────────────────────────── */
  function init() {
    if (!document.getElementById(CONTAINER)) return;

    hidePagination();

    if (nextUrl()) {
      placeSentinel();
      window.addEventListener('scroll', onScroll, { passive: true });
      /* Verifica subito se la griglia è già abbastanza corta */
      setTimeout(onScroll, 100);
      setTimeout(onScroll, 800);
    }

    watchContainer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
